import * as React from 'react'
import { createRoot } from 'react-dom/client';
import App from './App';

// File should be "index.js" but with the current build process we will make sure the name is distinguishable.

const element = document.getElementById( 'post-filters-archive' );
const root = createRoot( element );

const settings = {
    apiBase: element.getAttribute('data-api-base'),
    postType: element.getAttribute('data-post-type') ?? 'post',
    postsPerPage: element.getAttribute('data-posts-per-page') ?? 12,
    showFilters: element.getAttribute('data-show-filters') ?? false,
}

if ( settings.apiBase.length ) {
    root.render( 
        <React.StrictMode>
            <App settings={ settings } /> 
        </React.StrictMode>
    );
}